import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateQuery,
  updateStorylineStartDate,
  updateStorylineEndDate,
  updateFromStorylines,
} from "../redux/querySlice";
import { Alert, Chip, CircularProgress, Typography } from "@mui/material";
import DebugPanel from "./Debug";
import { useSocket } from "../constants/useSocket";
import { generateDebugDrawerContent } from "./Messages";
import { useTheme } from "@mui/material";

import EventIcon from "@mui/icons-material/Event";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { updateCurrentStoryline } from "../redux/keysegmentsAndStorylinesSlice";
import { updateQueryType } from "../redux/querySlice";

export default function Storylines(props) {
  const theme = useTheme();
  let socket = useSocket();
  const dispatch = useDispatch();
  const currentStoryline = useSelector(
    (state) => state.keysegmentsAndStorylines.currentStoryline
  );
  const devToolAccess = sessionStorage.getItem("devtools");
  let mode = sessionStorage.getItem("mode") || "dark";

  const storylineStartTime = useSelector(
    (state) => state.queryText.storylineStartDate
  );
  const storylineEndTime = useSelector(
    (state) => state.queryText.storylineEndDate
  );
  const loadingStatus = useSelector((state) => state.queryText.loading);
  const queryType = useSelector((state) => state.queryText.queryType);

  const [loadingStorylinesMsg, setLoadingStorylinesMsg] = useState("");
  const [noResults, setNoResults] = useState(false);

  const [errorMsg, setErrorMsg] = useState("");
  const [agentMessage, setAgentMessage] = useState("");
  const [debugMessages, setDebugMessages] = useState([]);
  const [openDebugPanel, setOpenDebugPanel] = useState(false);
  const [debugDrawerContent, setDebugDrawerContent] = useState([]);
  const [currentStorylinesLength, setCurrentStorylinesLength] = useState(0);
  const [hoveredStorylineId, setHoveredStorylineId] = useState(null);

  useEffect(() => {
    // dispatch(updateChatID(""));
    dispatch(updateStorylineStartDate(storylineStartTime));
    dispatch(updateStorylineEndDate(storylineEndTime));
    setLoadingStorylinesMsg("Curating Storylines");
  }, [props.query, dispatch, storylineStartTime, storylineEndTime]);

  useEffect(() => {
    setCurrentStorylinesLength(props?.stories?.length);
    if (props?.stories?.length > 0 && props?.compilation?.length === 0) {
      if (
        (props?.stories[0]?.voiceOverStory ||
          props?.stories[0]?.videoStory ||
          props?.stories[0]?.isQA) &&
        !currentStoryline &&
        !props?.socketComplete &&
        props?.stories?.length > currentStorylinesLength
      ) {
        dispatch(updateCurrentStoryline(props?.stories[0]));
      } else if (!currentStoryline && props?.socketComplete) {
        dispatch(updateCurrentStoryline(props?.stories[0]));
        dispatch(
          updateStorylineStartDate(
            props?.stories[0]?.start_time?.["epoch_millis"]
          )
        );
        dispatch(
          updateStorylineEndDate(props?.stories[0]?.end_time?.["epoch_millis"])
        );
        dispatch(updateFromStorylines(true));
        dispatch(updateQuery("Story on " + props?.stories[0]?.text));
        dispatch(updateQueryType("storylineQuery"));
      }
    }
  }, [props?.stories, props?.socketComplete]);
  // }, [props?.stories, currentStoryline, props.socketResults, dispatch, queryType, currentStorylinesLength, props?.socketComplete]);

  return (
    <div id="storylines">
      <div className="stories">
        {props.isCurationCancelled && !props.stories.length > 0 && (
          <h5 style={{ textAlign: "center" }}>Query Canceled</h5>
        )}
        {!props.isCurationCancelled &&
          !props.socketComplete &&
          props.stories.length < 1 &&
          !errorMsg && (
            <div className="prompt flex-center-center">
              <code class="progress">
                {/* {loadingStorylinesMsg} */}
                <CircularProgress
                  size={18}
                  thickness={8}
                  sx={{
                    marginLeft: "12px",
                    verticalAlign: "middle",
                    color: "#AC1FFF",
                  }}
                />
              </code>
            </div>
          )}

        {errorMsg.length > 1 && props.stories && props.stories.length < 1 && (
          <>
            <Alert variant="text" severity="error" sx={{ borderRadius: 48 }}>
              {errorMsg}
            </Alert>
          </>
        )}

        {props.stories && props.stories.length > 0 && (
          <div className="prompt">
            {/* <code className="progress" style={{ paddingBottom: 6 }}>
              Storylines
              <br />
              <span style={{ fontWeight: 400, display: "contents" }}>
                {agentMessage}
              </span>
            </code> */}
            {/* {devToolAccess == "true" ? (
              <ManageSearchIcon
                style={{ cursor: "pointer", marginLeft: 12, fontSize: 20 }}
                onClick={() => {
                  if (props.debug_messages.length > 1) {
                    setDebugDrawerContent(
                      generateDebugDrawerContent(props.debug_messages)
                    );
                  }
                  setOpenDebugPanel(true);
                }}
              />
            ) : null} */}
          </div>
        )}

        {/* {!loadingStatus && props.stories.length < 1 && (
          <>
            {props?.agentText && (
              <p
                style={{
                  marginTop: "0",
                  fontSize: 16,
                  padding: "0 24px 0 0",
                }}
              >
                {props.agentText}
              </p>
            )}
            <code className="progress">{props.message}</code>
          </>
        )} */}
        <div className="stories-container" style={{ height: "100%" }}>
          {props?.stories && (
            <div className="carousel-titles" style={{ height: "100%" }}>
              {props?.stories?.map((item) => (
                <div
                  key={item?.id}
                  onClick={() => {
                    socket.close();
                    dispatch(updateCurrentStoryline(item));
                    dispatch(
                      updateStorylineStartDate(
                        item?.start_time?.["epoch_millis"]
                      )
                    );
                    dispatch(
                      updateStorylineEndDate(item?.end_time?.["epoch_millis"])
                    );
                    dispatch(updateFromStorylines(true));
                    dispatch(
                      updateQuery(
                        item?.voiceOverStory
                          ? `Make a voiceover story about ${item?.text}`
                          : `Story on ${item?.text}`
                      )
                    );
                    dispatch(updateQueryType("storylineQuery"));
                  }}
                  onMouseEnter={() => setHoveredStorylineId(item?.id)}
                  onMouseLeave={() => setHoveredStorylineId(null)}
                >
                  <div className="storyline-title" key={item?.id}>
                    {item?.isQA !== true && (
                      <div className="storyline-title-text">
                        <Typography
                          sx={{
                            // color:
                            //   mode === "light"
                            //     ? theme.palette.primary.dark
                            //     : theme.palette.primary.white,
                            color: hoveredStorylineId === item?.id
                              ? theme.palette.primary.main // Change to primary color on hover
                              : theme.palette.primary.white,
                            fontWeight:
                              item.id === currentStoryline?.id ? 1000 : 300,
                            transition: 'color 0.1s ease', // Smooth transition for color change
                          }}
                        >
                          {item?.text}
                        </Typography>

                        <EventIcon
                          sx={{ fontSize: 14, mr: "6px", color: "#666666" }}
                        />
                        {new Date(
                          item?.start_time?.["epoch_millis"]
                        ).toLocaleDateString("en-US") ===
                        new Date(
                          item?.end_time?.["epoch_millis"]
                        ).toLocaleDateString("en-US") ? (
                          <Chip
                            variant="outlined"
                            // icon={<EventIcon />}
                            size="small"
                            sx={{
                              border: 0,
                              marginRight: 0,
                              justifyContent: "left",
                              "& .MuiChip-label": {
                                textAlign: "left",
                                padding: 0,
                                opacity: 1,
                                textTransform: "uppercase",
                                fontFamily: "Roboto Condensed",
                              },
                            }}
                            label={new Date(
                              item?.start_time?.["epoch_millis"]
                            ).toLocaleDateString("en-US", {
                              month: "short",
                              day: "2-digit",
                              year: "numeric",
                            })}
                          />
                        ) : (
                          <Chip
                            variant="outlined"
                            // icon={<EventIcon />}
                            size="small"
                            sx={{
                              border: 0,
                              marginLeft: 0,
                              justifyContent: "left",
                              "& .MuiChip-label": {
                                textAlign: "left",
                                padding: 0,
                                lineHeight: 1,
                                opacity: 1,
                                textTransform: "uppercase",
                                fontFamily: "Roboto Condensed",
                              },
                            }}
                            label={
                              new Date(
                                item?.start_time?.["epoch_millis"]
                              ).toLocaleDateString("en-US", {
                                month: "short",
                                day: "2-digit",
                              }) +
                              " - " +
                              new Date(
                                item?.end_time?.["epoch_millis"]
                              ).toLocaleDateString("en-US", {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              })
                            }
                          />
                        )}
                        <br />
                      </div>
                    )}
                    {/* <ArrowForwardIcon className="storyline-title-arrow" /> */}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {props.socketComplete && props.stories.length < 1 && (
          <Alert
            className="flex-center-center"
            variant="text"
            severity="error"
            sx={{ borderRadius: 48 }}
          >
            No storylines were found. Please try a different query.
          </Alert>
        )}
      </div>
      <DebugPanel
        openDebugPanel={openDebugPanel}
        handleDebugPanelClose={() => {
          setOpenDebugPanel(false);
        }}
        debugDrawerContent={debugDrawerContent}
      />
    </div>
  );
}
